import BookshelfMascot from "../images/Mascot waving.png";

export default function Companion() {
  return (
    <section className="bg-accent-light py-18">
    <div className="flex flex-col md:flex-row items-center justify-center gap-10 max-w-5xl mx-auto text-center md:h-96 px-6 py-24">
      <img src={BookshelfMascot} alt="Bookshelf mascot" className="w-auto h-48 md:h-64"/>
      <div className="flex flex-col gap-4 py-6">
        <h2 className="text-4xl font-normal">Your New Reading Companion</h2>
        <p className="text-lg">Meet your friendly chipmunk guide! Inside the app, this wise and warm companion will be with you throughout your reading journey—celebrating your progress, suggesting new discoveries, and creating a cozy space where every page turned is a small victory.</p>
        <p className="text-lg">Because reading should feel like coming home, and everyone needs a friend who understands the magic of a really good book.</p>
      </div>
    </div>
    </section>
  );
}